
// axios
import axios from "axios";
// option
import { ClientOption } from "../../../config/clientOption";

export const GetBanners = async () => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}banners`, ClientOption);
    return response.data;
}